import React from 'react';

import { Button, Modal } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { DEFAULT_POINT, reducePrecision, TestGeoProps } from 'client/blocks/TestChat/TestGeo';
import * as keyset from 'i18n/TestPage';

import styles from './AliceAppTestGeo.module.scss';

const t = i18n(keyset);

export const AliceAppTestGeo = ({ onSubmit, onCancel }: TestGeoProps) => {
    const [point, setPoint] = React.useState(DEFAULT_POINT);
    React.useLayoutEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let _map: any;
        // setTimeout чтобы модал успел отрисовать детей
        window.setTimeout(() => {
            const map = new ymaps.Map('test-geo-map', {
                center: DEFAULT_POINT,
                zoom: 10,
                controls: ['zoomControl', 'geolocationControl'],
            });
            const placemark = new ymaps.Placemark(
                DEFAULT_POINT,
                {},
                {
                    preset: 'islands#redIcon',
                },
            );
            map.geoObjects.add(placemark);

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function updatePoint(e: any) {
                const coords = e.get('coords');
                setPoint(coords);
                placemark.geometry?.setCoordinates(coords);
            }

            map.events.add(['click'], updatePoint);
            const searchControl = new ymaps.control.SearchControl({
                options: {
                    provider: 'yandex#search',
                    noPopup: true,
                    noPlacemark: true,
                },
            });
            map.controls.add(searchControl);
        });
        return () => {
            _map?.destroy();
        };
    }, []);

    const formattedPoint = point.map(reducePrecision).join(' ');
    const onSubmitCb = React.useCallback(() => {
        onSubmit({ lat: reducePrecision(point[0]), lon: reducePrecision(point[1]) });
    }, [onSubmit, point]);
    return (
        <Modal open>
            <div className={styles.testGeo}>
                <div className={styles.testGeo__map} id="test-geo-map" />
                <div className={styles.testGeo__footer}>
                    <div>
                        {t('point-selected')} <strong>{formattedPoint}</strong>
                    </div>
                    <div>
                        <Button size="l" onClick={onCancel}>
                            {t('cancel')}
                        </Button>
                        <Button className={styles.testGeo__button} view="action" size="l" onClick={onSubmitCb}>
                            OK
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
